export async function readBoundedArrayBuffer(request, maxBytes, tooLargeMessage, signal) {
  signal?.throwIfAborted();
  const limit = Math.max(0, Math.trunc(Number(maxBytes) || 0));
  const declaredValue = request.headers.get('content-length');
  const declaredBytes = declaredValue == null || declaredValue === '' ? null : Number(declaredValue);
  if (Number.isFinite(declaredBytes) && declaredBytes > limit) {
    // Preview callers explicitly own cancellation; legacy inbound callers may
    // reject a declared size without accessing the request body at all.
    if (signal) await request.body?.cancel().catch(() => {});
    throw new Error(tooLargeMessage);
  }
  if (!request.body) return new ArrayBuffer(0);

  const reader = request.body.getReader();
  const abort = () => { void reader.cancel().catch(() => {}); };
  signal?.addEventListener('abort', abort, { once: true });
  const chunks = [];
  let totalBytes = 0;
  try {
    while (true) {
      const { value, done } = await reader.read();
      signal?.throwIfAborted();
      if (done) break;
      const chunk = value instanceof Uint8Array ? value : new Uint8Array(value);
      totalBytes += chunk.byteLength;
      if (totalBytes > limit) {
        await reader.cancel(tooLargeMessage).catch(() => {});
        throw new Error(tooLargeMessage);
      }
      chunks.push(chunk);
    }
  } finally {
    signal?.removeEventListener('abort', abort);
    reader.releaseLock();
  }

  const bytes = new Uint8Array(totalBytes);
  let offset = 0;
  for (const chunk of chunks) {
    bytes.set(chunk, offset);
    offset += chunk.byteLength;
  }
  return bytes.buffer;
}
